/* ================================================== */
/* COMPONENTS > Medias
/* ================================================== */

$(document).ready(function(){

	var $medias = $('.medias'),
		$videos = $('.tab-pane--videos', $medias),
		$photos = $('.tab-pane--photos', $medias);

	// Videos
	$('.link', $videos).click(function() {
		var newItem = $(this).data('source');
		$(newItem).appendTo('.active__new', $videos);

		var $newIframe = $('.active__new iframe'),
			newWidth   = $newIframe.width(),
			newHeight  = $newIframe.height();

		setTimeout(function() {
			var newWidth = $newIframe.width();
			$newIframe.width(newWidth).height(newWidth * (newHeight / newWidth));
			$(window).trigger('resize');
			$('.active__current iframe').fadeTo(0, 400).remove();
		}, 400);
	});

	// Photos
	$('.link', $photos).click(function() {
		var newItem    = $(this).data('source'),
			$activeNew = $('.active__new', $photos);
		$($activeNew).html(newItem);

		$('.active__new', $photos).imagesLoaded( function() {
			$('.active__current img', $photos).fadeTo(0, 400).remove();
			$('img', $activeNew).appendTo($activeNew);
		});
	});

});